import React from "react";
import { TextField, SxProps, Theme } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface ManualAddressTextFieldProps {
  name: string;
  control: Control<Record<string, unknown>>;
  label: string;
  required?: boolean;
  error?: { message?: string };
  testId?: string;
  inputSx?: SxProps<Theme>;
  size?: "small" | "medium";
}

const ManualAddressTextField: React.FC<ManualAddressTextFieldProps> = ({
  name,
  control,
  label,
  required = false,
  error,
  testId,
  inputSx,
  size = "medium"
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <TextField
        {...field}
        label={label}
        required={required}
        fullWidth
        size={size}
        error={!!error}
        helperText={error?.message}
        inputProps={testId ? { "data-testid": testId } : undefined}
        sx={inputSx}
      />
    )}
  />
);

export default ManualAddressTextField;
